module.exports = __webpack_public_path__ + "static/media/fusspot.7a18fb35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fusspot.jpg
// module id = 1623
// module chunks = 0